import React, { PureComponent, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { Segment, Header, Grid, Statistic } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import { get as getTeacherAnalytics } from 'actions/teacher-analytics';

import StudentAnalyticsAggregate from '../student-analytics';

import RatingsChart from '../teacher-analytics/components/ratings-chart';
import UtilizationSunburst from '../teacher-analytics/components/utilization-sunburst';
import { median } from '../teacher-analytics/utils/data-parser';

class SingleTeacherAnalytics extends PureComponent {
  constructor(props) {
    super(props);
    var monthFinal = moment().format('MMMM');
    var yearFinal = moment().format('YYYY');
    this.state = {
      teacherId: props.match.params.teacherId,
      teacherData: null,
      teacherName: null,
      queryObj: {
        teacher_id: props.match.params.teacherId,
        initial_month: '2018-September',
        final_month: yearFinal + '-' + monthFinal,
        data_type: 'MONTHLY',
        page: 1,
        page_size: 20,
      },
    };
  }

  static getDerivedStateFromProps({ teacherAggregateAnalytics }, prevState) {
    let newState = {};
    const teacherAggregateAnalyticsGet = store.get(
      teacherAggregateAnalytics,
      'ANALYTICS',
      prevState.queryObj,
    );
    if (teacherAggregateAnalyticsGet) {
      if (
        teacherAggregateAnalyticsGet.data &&
        prevState.teacherData !== teacherAggregateAnalyticsGet.data
      ) {
        if (
          teacherAggregateAnalyticsGet.data &&
          teacherAggregateAnalyticsGet.data.teachers_data
        ) {
          newState['teacherData'] = teacherAggregateAnalyticsGet.data.teachers_data[0];
        }
      }
    }
    if (newState === {}) {
      return null;
    }
    return newState;
  }

  componentDidMount() {
    const { getTeacherAnalytics } = this.props.actions;
    const { queryObj } = this.state;
    getTeacherAnalytics('ANALYTICS', queryObj);
  }

  render() {
    const { teacherId, teacherData } = this.state;
    if (!teacherId || !teacherData) {
      return <div> You shall not pass</div>;
    }
    let callsMadeTime = teacherData.total_call_time.filter(tm => tm !== 0);
    let meanDoubtToCallTimeList = [];
    teacherData.doubt_to_call_time.forEach(dbtCall => {
      if (dbtCall.length > 0) {
        meanDoubtToCallTimeList.push(_.sum(dbtCall) / dbtCall.length);
      }
    });
    let medianDbtToCallTime = median(meanDoubtToCallTimeList) / 60.0;
    let itemsAttempted = teacherData.num_items_attempted.filter(itm => itm !== 0);

    return (
      <Fragment>
        <Segment>
          {teacherData && (
            <div>
              <Header as="h1">{teacherData.name}</Header>
              <Header as="h3">{teacherData.phone}</Header>
            </div>
          )}
          {teacherData && (
            <div>
              <Grid columns={2} textAlign="center">
                <Grid.Row>
                  <Grid.Column width={8}>
                    <Header as="h3">Rating</Header>
                    <RatingsChart data={teacherData.rating_objs} />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Header as="h3">Utilization</Header>

                    <UtilizationSunburst
                      data={Object.values(teacherData.slots).map(
                        slt => slt.seats_occupied,
                      )}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid columns={1} textAlign={'center'} width={16}>
                <Grid.Row>
                  <Header as="h3">Other Metrics</Header>
                </Grid.Row>
                <Grid.Row columns={10} width={16}>
                  <Grid.Column>
                    <Statistic
                      size="tiny"
                      color={
                        teacherData.attendance * 100 < 85
                          ? 'red'
                          : teacherData.attendance * 100 < 93
                          ? 'yellow'
                          : 'green'
                      }
                    >
                      <Statistic.Label>Attendance</Statistic.Label>
                      <Statistic.Value>
                        {(teacherData.attendance * 100).toFixed(1)}%
                      </Statistic.Value>
                      <Statistic.Label>
                        out of {teacherData.classes_total} classes{' '}
                      </Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic
                      size="tiny"
                      color={median(callsMadeTime) < 5 ? 'red' : 'black'}
                    >
                      <Statistic.Label>Median Call Time</Statistic.Label>
                      <Statistic.Value>
                        {median(callsMadeTime).toFixed(1)}
                      </Statistic.Value>
                      <Statistic.Label>mins/student</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic
                      size="tiny"
                      color={medianDbtToCallTime > 8 ? 'red' : 'black'}
                    >
                      <Statistic.Label>Median Doubt to Call Time</Statistic.Label>
                      <Statistic.Value>{medianDbtToCallTime.toFixed(1)}</Statistic.Value>
                      <Statistic.Label>
                        mins/
                        <br />
                        Student/Class
                      </Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic
                      size="tiny"
                      color={teacherData.avg_time_on_worksheets < 35 ? 'red' : 'black'}
                    >
                      <Statistic.Label>Avg Time on Worksheet</Statistic.Label>
                      <Statistic.Value>
                        {teacherData.avg_time_on_worksheets.toFixed(1)}
                      </Statistic.Value>
                      <Statistic.Label>
                        mins
                        <br />
                        Student/Class
                      </Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic
                      size="tiny"
                      color={median(itemsAttempted) < 17 ? 'red' : 'black'}
                    >
                      <Statistic.Label># Items </Statistic.Label>
                      <Statistic.Value>
                        {median(itemsAttempted).toFixed(1)}
                      </Statistic.Value>
                      <Statistic.Label>/Student/Class</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic size="tiny">
                      <Statistic.Label>
                        #classes/
                        <br />
                        week
                      </Statistic.Label>
                      <Statistic.Value>{teacherData.num_slots}</Statistic.Value>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic size="tiny">
                      <Statistic.Label># Indian Students</Statistic.Label>
                      <Statistic.Value>
                        {teacherData.student_region_dict['INDIA']
                          ? Object.values(teacherData.student_region_dict['INDIA']).length
                          : 0}
                      </Statistic.Value>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic size="tiny">
                      <Statistic.Label># Columbus Students</Statistic.Label>
                      <Statistic.Value>
                        {teacherData.student_region_dict.USA
                          ? Object.values(teacherData.student_region_dict['USA']).length
                          : 0}
                      </Statistic.Value>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column>
                    <Statistic size="tiny">
                      <Statistic.Label>Average Completion/Student</Statistic.Label>
                      <Statistic.Value>
                        {teacherData.avg_completion !== -1
                          ? (teacherData.avg_completion * 100).toFixed(1) + '%'
                          : 'NA'}
                      </Statistic.Value>
                      <Statistic.Label>
                        per student per
                        <br />
                        month
                      </Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          )}
        </Segment>
        <Segment raised>
          {teacherId && (
            <StudentAnalyticsAggregate
              teacherID={teacherId}
              sendAggregateTeacherData={this.getTeacherClassroomData}
            />
          )}
        </Segment>
      </Fragment>
    );
  }
}

export default connect(
  ({ teacherAggregateAnalytics }) => ({
    teacherAggregateAnalytics: teacherAggregateAnalytics,
  }),
  dispatch => ({
    actions: bindActionCreators({ getTeacherAnalytics }, dispatch),
  }),
)(SingleTeacherAnalytics);
